import { Badge } from '../ui/badge';
import { TEMPLATES } from './TemplateProvider';
import type { TemplateType } from '../../types';

interface TemplateBadgeProps {
  template: TemplateType;
  variant?: 'default' | 'outline' | 'compact';
  showIcon?: boolean;
  className?: string;
}

// Template color mapping
const TEMPLATE_COLORS: Record<string, string> = {
  atlassian: 'bg-blue-600',
  custom: 'bg-gray-600',
  generic: 'bg-gray-600',
  servicenow: 'bg-red-600',
  ivanti: 'bg-green-600',
  'bmc-helix': 'bg-purple-600',
  freshservice: 'bg-teal-600',
};

export function TemplateBadge({ 
  template, 
  variant = 'default',
  showIcon = true,
  className = ''
}: TemplateBadgeProps) {
  const config = TEMPLATES.find(t => t.id === template);

  if (!config) {
    return null;
  }

  const color = TEMPLATE_COLORS[template];

  // Variant styles
  const variantStyles = {
    default: `${color} text-white border-0`,
    outline: `border-2 ${color.replace('bg-', 'border-')} ${color.replace('bg-', 'text-')} bg-transparent`,
    compact: `${color} text-white border-0 text-xs py-0.5 px-2`,
  };

  return (
    <Badge 
      className={`${variantStyles[variant]} ${className}`}
      variant="outline"
    >
      {showIcon && <span className="mr-1">{config.icon}</span>}
      {config.name}
    </Badge>
  );
}

export function TemplateIcon({ template, className = "" }: { template: TemplateType; className?: string }) {
  const config = TEMPLATES.find(t => t.id === template);

  if (!config) {
    return null;
  }

  const color = TEMPLATE_COLORS[template] || 'bg-gray-600';

  return (
    <span
      className={`inline-flex items-center justify-center w-7 h-7 rounded text-xs font-semibold text-white ${color} ${className}`}
    >
      {config.icon}
    </span>
  );
}